import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { addressI, Address } from 'app/core/interfaces/adress';
import { FormStateMatcher } from 'app/core/directives/form-validate';
import { DomSanitizer } from '@angular/platform-browser';
import { MapService } from 'app/core/http/services/map.service';
import { ViaCepService } from 'app/core/http/services/viacep.service';
import { PractitionerService } from 'app/core/http/services/practitioner.service';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { Practitioner } from 'app/core/interfaces/practitioner';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'page-practitioner-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss'],
})
export class PractitionerMapComponent extends BaseComponent implements OnInit {
  @Input() form: FormGroup = new FormGroup({});
  @Input() address: Address = <Address>{};
  @Input() practitioner: Practitioner = <Practitioner>{};
  @Output() onUpdatePractitioner = new EventEmitter<any>();
  @Input() mode = 'CREATE';

  private practitionerId = '';
  readonly mapStateMatcher = new FormStateMatcher('');
  public childForm: FormGroup = new FormGroup({});
  public mapUrl: string | null = null;
  public url = '';
  public zoom = 14;
  public isSaving = false;
  public submittedCep = false

  public cepError = false

  constructor(
    private injector: Injector,
    private fb: FormBuilder,
    private map: MapService,
    private practitionerService: PractitionerService,
    private viaCepService: ViaCepService,
    private domSanitizer: DomSanitizer
  ) {
    super(injector);

    this.childForm = this.fb.group({
      cep: new FormControl(null, [Validators.required, Validators.pattern(/^\d{5}-?\d{3}$/)]),
      number: new FormControl(null, [Validators.required]),
      country: new FormControl(null, [Validators.required]),
      city: new FormControl(null, [Validators.required]),
      state: new FormControl(null, [Validators.required]),
      street: new FormControl(null, [Validators.required]),
      district: new FormControl(null, [Validators.nullValidator]),
      complement: new FormControl(null, [Validators.nullValidator]),
    });
  }


  ngOnInit(): void {
    this.childForm.controls['cep'].setValue(this.address.cep);

    if (this.mode == 'CREATE') {
      this.practitionerId = this.practitioner.practitioner_id;
    }

    if (localStorage.getItem('isFirstAccess') == 'false') {
      this.getPractitioner();
    }

    this.getPractitioner();
  }

  buscarCEP() {
    this.dialog
      .openSearchCepDialog({
        param: {},
      })
      .subscribe((result: addressI | any) => {


        if (result.cep) {
          this.childForm.controls['cep'].setValue(result.cep);
          this.address.latitude = result.latitude;
          this.address.longitude = result.longitude;
          this.address.street = result.street ?? undefined;
          this.address.city = result.city;
          this.address.state = result.state;
          this.address.complement = result.complement;
          this.address.country = result.country;
          this.address.district = result.district;
        }
      });
  }

  allowOnlyLetters(event: KeyboardEvent): void {
    const inputChar = event.key;

    if (!/^[a-zA-ZÀ-ÿ\s]$/.test(inputChar)) {
      event.preventDefault();
    }
  }

  private getPractitioner() {
    const practitionerId = this.getUserLogged().id;

    this.practitionerService.showNew(practitionerId).subscribe({
      next: (practioner: Practitioner) => {
        this.practitioner = practioner;
        this.setValueToFormAddress(this.practitioner?.address);
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  searchAddressByCep() {

    this.submittedCep = true
    this.cepError = false

    const cep = this.childForm.controls['cep'].value

    this.viaCepService.findByCep(cep).subscribe({
      next: (res: any) => {

        if (!res.cep) {
          this.submittedCep = false
          this.cepError = true
          return
        }

        this.address.city = res?.localidade;
        this.address.state = res.uf;
        this.address.country = 'Brasil';
        this.address.street = res?.logradouro;

        this.submittedCep = false

        this.onChangeForm({})
      },
      error: (err: HttpErrorResponse) => {
        this.submittedCep = false
        this.cepError = true
        console.log(err);
      },
    });
  }

  setValueToFormAddress(address?: Address) {
    if (!address) return;

    this.address.city = address?.city;
    this.childForm.controls['cep'].setValue(address?.cep);
    this.address.cep = address?.cep;
    this.address.state = address?.state;
    this.address.country = address?.country;
    this.address.district = address?.district;
    this.address.street = address.street;
    this.address.number = address.number;
    this.address.complement = address.complement;
  }

  save() {
    this.showErrorMessage = false;
    this.showSuccessMessage = false;
    this.loading = true;
    this.isSaving = true;

    const practitioner_id = this.getUserLogged().id;
    this.practitioner.address = this.address;

    this.practitionerService.updateNew(practitioner_id, this.practitioner).subscribe({
      next: (practitioner: Practitioner) => {
        this.practitioner = practitioner;
        this.isSaving = false;
        this.showErrorMessage = false;
        this.showSuccessMessage = true;
        this.loading = false;

        this.onUpdatePractitioner.emit(practitioner)
      },
      error: (err) => {
        this.showErrorMessage = true;
        this.showSuccessMessage = false;
        this.isSaving = false;
        this.loading = false;
      },
    });
  }

  loadAddress(cep: string) {
    if (cep.length == 8) {
      const values = this.map.getLatLong(cep);
    }
  }

  onChangeForm(event: any) {
    this.address.cep = this.layout.getOnlyNumbers(this.childForm.get('cep')?.value).toString();

    this.childForm.patchValue({
      cep: this.address?.cep || null,
      number: this.address?.number || null,
      country: 'Brasil',
      city: this.address?.city || null,
      state: this.address?.state || null,
      street: this.address?.state || null,
      district: this.address?.district || null,
      complement: this.address?.complement || null,
    })
  }

  markAsTouched() {
    for (var i in this.childForm.controls) {
      this.form.controls[i].markAsTouched();
    }
  }
}
